import { Chip, List, ListItem, ListItemIcon, ListItemText } from "@mui/material";

import type { WorkoutAnswer, WorkoutUser } from "../../api/workout-service";

import Avatar from "./Avatar";

export type UserListProps = {
    users: WorkoutUser[];
    answers?: WorkoutAnswer[];
};

function isUserAnswered(answers: WorkoutAnswer[] | undefined, userId: string): boolean {
    return !!answers?.find((answer) => answer.user === userId);
}

export default function UserList({ users, answers }: UserListProps): JSX.Element {
    return <List>
        {
            users?.map((user) => (
                <ListItem key={ `user-${ user.id }` }
                          secondaryAction={
                              isUserAnswered(answers, user.id) ? <Chip label="Ready" color="primary"/> : <></>
                          }>
                    <ListItemIcon>
                        <Avatar userId={ user.id } size="md"/>
                    </ListItemIcon>

                    <ListItemText primary={ user.name } secondary={ `(${ user.id })` }/>
                </ListItem>
            ))
        }
    </List>;
}
